(function () {
    'use strict';

    angular.module("imApp").factory("accountService", ['$ihttp', function ($ihttp) {
        let service = {
            getAccount: function (parms) {
                return $ihttp.post({
                    method: 2940,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2941,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
